const Contact = () => {
  return (
    <section id="contact" className="text-gray-600 body-font relative">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1
            className="
              text-5xl
              font-medium
              title-font
              mb-4
            "
          >
            Contact Us
          </h1>
          <div className="flex mt-6 justify-center">
            <div
              className="
                w-28
                h-2
                rounded-full
                bg-purple-500
                inline-flex
              "
            ></div>
          </div>
        </div>
        <div className="lg:w-1/2 md:w-2/3 mx-auto">
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <input type="hidden" name="form-name" value="contact" />
            <div hidden>
              <input name="bot-field" />
            </div>
            <div className="flex flex-wrap -m-2">
              <div className="p-2 w-1/2">
                <div className="relative">
                  <label
                    htmlFor="name"
                    className="leading-7 text-sm text-gray-600"
                  >
                    Name
                  </label>
                  <input
                    required
                    type="text"
                    id="name"
                    name="name"
                    className="
                      w-full
                      bg-gray-100 bg-opacity-50
                      rounded
                      border border-gray-300
                      focus:border-purple-500
                      focus:bg-white
                      focus:ring-2 focus:ring-purple-200
                      text-base
                      outline-none
                      text-gray-600
                      py-1
                      px-3
                      leading-8
                      transition-colors
                      duration-200
                      ease-in-out
                    "
                  />
                </div>
              </div>
              <div className="p-2 w-1/2">
                <div className="relative">
                  <label
                    htmlFor="email"
                    className="leading-7 text-sm text-gray-600"
                  >
                    Email
                  </label>
                  <input
                    required
                    type="email"
                    id="email"
                    name="email"
                    className="
                      w-full
                      bg-gray-100 bg-opacity-50
                      rounded
                      border border-gray-300
                      focus:border-purple-500
                      focus:bg-white
                      focus:ring-2 focus:ring-purple-200
                      text-base
                      outline-none
                      text-gray-600
                      py-1
                      px-3
                      leading-8
                      transition-colors
                      duration-200
                      ease-in-out
                    "
                  />
                </div>
              </div>
              <div className="p-2 w-full">
                <div className="relative">
                  <label
                    htmlFor="message"
                    className="leading-7 text-sm text-gray-600"
                  >
                    Message
                  </label>
                  <textarea
                    required
                    id="message"
                    name="message"
                    className="
                      w-full
                      bg-gray-100 bg-opacity-50
                      rounded
                      border border-gray-300
                      focus:border-purple-500
                      focus:bg-white
                      focus:ring-2 focus:ring-purple-200
                      h-32
                      text-base
                      outline-none
                      text-gray-600
                      py-1
                      px-3
                      resize-none
                      leading-6
                      transition-colors
                      duration-200
                      ease-in-out
                    "
                  ></textarea>
                </div>
              </div>
              <div className="p-2 w-full">
                <button
                  type="submit"
                  className="
                    flex
                    mx-auto
                    text-white
                    bg-purple-500
                    border-0
                    py-2
                    px-8
                    focus:outline-none
                    hover:bg-purple-600
                    rounded
                    text-lg
                  "
                >
                  Send
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
